import GoalsContainer from "source/app/presentation/MainPanel/Goals/GoalsContainer";

export const GetActiveDailyGoals = (goalsContainer: GoalsContainer) =>
    goalsContainer.state.Goals.filter(
        (goal) => goal.istracking && !goal.isarchived && goal.isdaily
    );
